import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Scenes } from '../models/scenes.enum';
import { startOnScene } from '../../../assets/config/scenes-data';

@Injectable({
  providedIn: 'root'
})
export class RenderService {
  selectedScene: BehaviorSubject<Scenes>;

  constructor() {
    this.selectedScene = new BehaviorSubject<Scenes>(startOnScene);
  }

  selectScene(scene: Scenes): void {
    // if (this.selectedScene.value !== scene) {
      this.selectedScene.next(scene);
    // }
  }
}
